<template>
    <div class="d-flex">
        <loading :active='isLoading'/>

        <div class="d-none d-lg-block col-lg-2 col-xl-2"></div>
        <div class="col-12 col-lg-8 col-xl-8">
            <template v-if="state == 1">
                <form-personal v-model="personal" :invalid="invalid"></form-personal>
                <div v-if="mode == 'REGISTERED'"  class="form-check">
                    <input class="form-check-input" type="checkbox" v-model="updateAccount" id="update-user-checkbox">
                    <label class="form-check-label" for="update-user-checkbox">
                        Update user information
                    </label>
                </div>
                <div class="d-flex justify-content-between mt-3 mb-3">
                    <button type="button" class="btn btn-primary" @click="$router.go(-1)"><i class="fas fa-arrow-circle-left me-2"></i>Back</button>
                    <button type="button" class="btn btn-primary" @click="submitPersonal">Next<i class="fas fa-arrow-circle-right ms-2"></i></button>
                </div>
            </template>
            <template v-if="state == 2">
                <form-org v-model="org" :invalid="invalid" class="mt-4"></form-org>
                <div v-if="mode == 'REGISTERED'"  class="form-check">
                    <input class="form-check-input" type="checkbox" v-model="updateAccount" id="update-user-checkbox">
                    <label class="form-check-label" for="update-user-checkbox">
                        Update organization information
                    </label>
                </div>

                <div class="d-flex justify-content-between mt-3 mb-3">
                    <button type="button" class="btn btn-primary" @click="state = 1"><i class="fas fa-arrow-circle-left me-2"></i>Back</button>
                    <button type="button" class="btn btn-primary" @click="submitOrg">Next<i class="fas fa-arrow-circle-right ms-2"></i></button>
                </div>
            </template>
            <template v-if="state == 3">
                <form-custom :questions="data.event._ReqQuestions" v-model="customs"></form-custom>
                <div class="d-flex justify-content-between mt-3 mb-3">
                    <button type="button" class="btn btn-primary" @click="state = 2"><i class="fas fa-arrow-circle-left me-2"></i>Back</button>
                    <button type="button" class="btn btn-primary" @click="submitCustom">Next<i class="fas fa-arrow-circle-right ms-2"></i></button>
                </div>

            </template>
            <template v-if="state == 4">
                <form-payment v-model="payment" :event="data.event" :user="data.user" ref="pay_form"></form-payment>
                <div class="d-flex justify-content-between mt-3 mb-3">
                    <button type="button" class="btn btn-primary" @click="state = 2"><i class="fas fa-arrow-circle-left me-2"></i>Back</button>
                    <button type="button" class="btn btn-primary" @click="submitPay">Submit<i class="fas fa-arrow-circle-right ms-2"></i></button>
                </div>
            </template>
            <template v-if="state == 5">
                <form-enrolled :transaction="transaction"></form-enrolled>
            </template>
        </div>
    </div>
</template>

<script>
import FormPersonal from './components/FormPersonal.vue';
import FormOrg from './components/FormOrg.vue';
import FormCustom from './components/FormCustom.vue';
import FormPayment from './components/FormPayment.vue';
import FormEnrolled from './components/FormEnrolled.vue';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    components: { 
        Loading,
        FormPersonal,
        FormOrg,
        FormCustom,
        FormPayment,
        FormEnrolled,
    },

    mounted() {
        if (this.$route.params.event == 'test') {
            console.log('TEST MODE');
            this.testing();
            return;
        }

        this.isLoading = true;
        axios
            .get(`/api/enroll/${this.$route.params.event}`)
            .then(response => {
                // console.log(response.data);
                this.data.user = response.data.user;
                this.$root.square = response.data.square;
                const user = response.data.user ?? {};
                this.personal = {
                    address: user.address ?? '',
                    city: user.city ?? '',
                    email: user.email ?? '',
                    first_name: user.first_name ?? '',
                    last_name: user.last_name ?? '',
                    member: user.member ?? '',
                    name: user.name ?? '',
                    state: user.state,
                    zip: user.zip ?? '',
                    phone: user.phone,
                    event: response.data.event,
                };
                this.org = {
                    job_title: user.job_title,
                    org_address: user.org_address,
                    org_building: user.org_building,
                    org_city: user.org_city,
                    org_id: user.org_id,
                    org_name: user.org_name,
                    org_state: user.org_state,
                    org_zip: user.org_zip,
                    event: response.data.event,
                };
                this.data.event = response.data.event;
                this.state = 1;
                // console.debug(response.data);
            })
            .catch(error => {
                console.error(error);
            })
            .finally(() => {
                this.isLoading = false;
            })
    },

    computed: {
        mode: function() {
            return this.data.user === null ? 'GUEST' : 'REGISTERED';
        },

        nextState: function() {
            const $quest = this.data.event._ReqQuestions ? this.data.event._ReqQuestions.length : 0;
            if (this.state == 2 && $quest) {
                return 3;
            } else if (this.state == 2) {
                return 4;
            } else if (this.state == 5) {
                return 5;
            } else {
                return parseInt(this.state) + 1;
            }
        }
    },

    watch: {
        state: function(n, o) {
            if (n == 5) {
                this.session = '';
            }
        }
    },

    methods: {
        testing: function() {
            //const trans = 'D7282507-3367-774C-93EA-14B76636C820';
            const trans = '2466F65C-85C0-45BC-844D-ED30B28BA812';
            axios
                .get(`/api/transaction/testing/${trans}`)
                .then(response => {
                    this.transaction = response.data.data;
                    console.debug('↯↯TESTING↯↯')
                    console.log(response.data);
                })
                .finally(() => {
                    this.state = 5;
                });
        },

        errorHandle(error, callback=()=>{}) {
            console.error(error);
            if (error.response.status == 422) {
                let message = [];

                this.invalid = Object.keys(error.response.data.errors);

                for (const [field, messages] of Object.entries(error.response.data.errors)) {
                    console.warn(`${field}: ${messages}`);
                    messages.forEach(m => { message.push(`<li class='list-group-item'>${m}</li>`) });
                }

                message = message.join('');
                message = `<ul class='list-group list-group-flush'>${message}</ul>`;

                this.$swal({
                    title: 'Problem',
                    icon: 'error',
                    html: message,
                })
                .then( ()=> {
                    callback();
                });
            } else if (error.response.status == 500) {
                this.$swal({
                    title: 'Problem',
                    icon: 'error',
                    html: '<p>The request could not be processed. There was an error on the server.<p>',
                })
                .then( ()=> {
                    callback();
                });
            } else {
                this.$swal({
                    title: 'Problem',
                    icon: 'error',
                    html: '<p>The request could not be processed. There was an unspecified error.<p>',
                })
                .then( ()=> {
                    callback();
                });

            }
            console.error(error);
        },

        submit: function(url, data, callback=function(response){} ) {
            this.isLoading = true;
            data['event'] = this.data.event.EventID;
            data['session'] = this.session;
            data['update'] = this.updateAccount;
            axios
                .post(url, data)
                .then(response => {
                    if (!response.data.session && !response.data.data.session) {
                        this.$swal({
                            title: 'Problem',
                            icon: 'error',
                            html: 'An unknown error occured'
                        });
                        console.error('Invalid session id');
                        console.warn(response.data);
                        return;
                    }

                    this.session = response.data.session;
                    this.state = this.nextState;
                    callback(response.data);
                })
                .catch(error => {
                    this.errorHandle(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        submitPersonal: function() {
            this.submit(`/api/enroll/${this.data.event.EventID}/user`, this.personal);
        },

        submitOrg: function() {
            this.submit(`/api/enroll/${this.data.event.EventID}/org`, this.org);
        },

        submitCustom: function() {
            const result = this.data.event._ReqQuestions.map(qu => {
                return {
                    QuestionID: qu.QuestionID,
                    Response: this.customs[qu.QuestionID] ?? null,
                }
            });
            this.submit(`/api/enroll/${this.data.event.EventID}/custom`, {data: result});
        },

        submitPay: async function() {
            this.isLoading = true;
            try {
                await this.$refs.pay_form.submit();
            } catch(err) {
                // console.error(err);
                this.errorHandle(err);
                return;
            } finally {
                this.isLoading = false;
            }

            const callback = data => { 
                this.transaction = data;
            };
            this.submit(`/api/enroll/${this.data.event.EventID}/payment`, this.payment, callback);
        },
    },

    data() {
        return {
            invalid: [],

            state: 1,
            personal: {},
            org: {},
            customs: {},
            payment: {},
            transaction: {},
            updateAccount: true,
            
            data: {
                user: {},
                event: {}
            },

            isLoading: false,
            session: '',
        }
    }
}

</script>